module.exports = __webpack_public_path__ + "img/DIS Préhistoire FR Profile.e8caa8b7.webp";